<section [ngClass]="dynamicClass">
  <div class="eq-container">
    <div *ngIf="rendering.fields?.IsTable.value" class="lg:eq-w-[77%] lg:eq-mx-auto">
      <div class="eq-w-full eq-rich-content" [ngClass]="twoTables ? 'two-tables eq-w-full eq-rich-content' : ''" [innerHTML]="rendering.fields?.Content?.value  | TrustHtml"></div>
    </div>
    <div *ngIf="!rendering.fields?.IsTable.value" class="lg:eq-w-[77%] lg:eq-mx-auto">
      <div class="eq-w-full eq-rich-content" [innerHTML]="rendering.fields?.Content?.value | TrustHtml"></div>
    </div>
  </div>
</section>
